var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9364 12.1796L24.7931 17.0563C23.8131 21.2679 21.8764 22.9713 18.2364 22.6213C17.6531 22.5746 17.0231 22.4696 16.3464 22.3063L14.3864 21.8396C9.52139 20.6846 8.01639 18.2813 9.15972 13.4046L10.3031 8.51627C10.5364 7.5246 10.8164 6.66127 11.1664 5.9496C12.5314 3.12627 14.8531 2.36794 18.7497 3.2896L20.6981 3.7446C25.5864 4.88794 27.0797 7.30294 25.9364 12.1796Z",
    stroke: "#046242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2364 22.6209C17.5131 23.1109 16.6031 23.5192 15.4947 23.8809L13.6514 24.4876C9.01975 25.9809 6.58141 24.7326 5.07641 20.1009L3.58308 15.4926C2.08975 10.8609 3.32641 8.41089 7.95808 6.91755L9.80141 6.31089C10.2797 6.15922 10.7347 6.03089 11.1664 5.94922C10.8164 6.66089 10.5364 7.52422 10.3031 8.51589L9.15975 13.4042C8.01641 18.2809 9.52141 20.6842 14.3864 21.8392L16.3464 22.3059C17.0231 22.4692 17.6531 22.5742 18.2364 22.6209Z",
    stroke: "#046242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4131 9.95215L21.0714 11.3871",
    stroke: "#046242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2698 14.4668L17.6531 15.3301",
    stroke: "#046242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event-icon.9b52eba732e5808b228b459b0d83af90.svg";
export { ForwardRef as ReactComponent };